import React, { useState } from "react";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";

const PopupUccNseError = (props) => {
    const { data, /* isOpen, */ toggleModal, isAdvisory, redirectToPartner } = props;

    const handleButtonClick = () => {
        toggleModal(false);
    }

    return (<>
        <Modal isOpen={true} centered className="popup-ucc-nse-error">
            <ModalBody className="m-auto text-center" style={{ minWidth: "400px" }}>
                <img
                    className="img-icon mt-3"
                    src={(data.status === "success" || data.status === "pending" || data.status === "onhold")
                        ? process.env.REACT_APP_IMAGES_PATH + "success1.webp"
                        : process.env.REACT_APP_IMAGES_PATH + "failure_1.webp"
                    }
                    alt="result-icon" />

                <h5 className="title">
                    {data.title}
                </h5>

                {
                    data.message &&
                    <div className={"content "
                        + (data.status == "success"
                            ? "success"
                            : data.status == "failed" ? "failed" : "")}
                        dangerouslySetInnerHTML={{ __html: data.message }}>
                    </div>
                }

                {
                    (data?.orderId && !isAdvisory) && <p className="order-id">
                        Order Id : {data?.orderId}
                    </p>
                }

                <div className="c-btn">
                    {
                        data.spinner && <div className="c-spinner">
                            <Spinner size="sm" color="secondary" />
                        </div>
                    }
                    {
                        data.note && <p className="note"
                            dangerouslySetInnerHTML={{ __html: data.note }}></p>
                    }

                    {data.showCloseBtn &&
                        <Button
                            size="md"
                            color={"link"}
                            onClick={() => {
                                if (isAdvisory) {
                                    if (data.status === "pending" || data.status === "onhold") {
                                        redirectToPartner(true, "success", data?.orderId); // In case fo NEFT payment (as its status always be 'pending')
                                    } else {
                                        redirectToPartner(true, data.status, data?.orderId);
                                    }
                                } else {
                                    if (data.reloadPage) {
                                        window.location.reload();
                                    } else if (data.redirectWithCleanParams) {
                                        window.location.href = data.redirectWithCleanParams;
                                        window.location.reload();
                                    } else {
                                        handleButtonClick()
                                    }
                                }
                            }}
                        >
                            Close
                        </Button>
                    }
                </div>
            </ModalBody>
        </Modal>
    </>
    )
}

export default PopupUccNseError;